"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = __importDefault(require("react"));
var attendance_40_svg_1 = __importDefault(require("@/assets/svg/attendance-40.svg"));
var late_40_svg_1 = __importDefault(require("@/assets/svg/late-40.svg"));
var absent_40_svg_1 = __importDefault(require("@/assets/svg/absent-40.svg"));
var presentation_40_svg_1 = __importDefault(require("@/assets/svg/presentation-40.svg"));
var project_success_40_svg_1 = __importDefault(require("@/assets/svg/project-success-40.svg"));
var project_fail_40_svg_1 = __importDefault(require("@/assets/svg/project-fail-40.svg"));
var leader_40_svg_1 = __importDefault(require("@/assets/svg/leader-40.svg"));
var sub_leader_40_svg_1 = __importDefault(require("@/assets/svg/sub-leader-40.svg"));
var staff_40_svg_1 = __importDefault(require("@/assets/svg/staff-40.svg"));
var project_leader_40_svg_1 = __importDefault(require("@/assets/svg/project-leader-40.svg"));
var project_sub_leader_40_svg_1 = __importDefault(require("@/assets/svg/project-sub-leader-40.svg"));
var prepare_40_svg_1 = __importDefault(require("@/assets/svg/prepare-40.svg"));
var default_score_40_svg_1 = __importDefault(require("@/assets/svg/default-score-40.svg"));
var content_write_40_svg_1 = __importDefault(require("@/assets/svg/content-write-40.svg"));
var constants_1 = require("../constants");
var scoreIcon = (_a = {},
    _a[constants_1.ScoreType.ATTENDANCE] = (0, jsx_runtime_1.jsx)(attendance_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.LATE] = (0, jsx_runtime_1.jsx)(late_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.ABSENT] = (0, jsx_runtime_1.jsx)(absent_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.SEMINAR_PRESENTATION] = (0, jsx_runtime_1.jsx)(presentation_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.ADD_SCORE_DURING_SEMINAR_ACTIVITY_0_5] = (0, jsx_runtime_1.jsx)(presentation_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.ADD_SCORE_DURING_SEMINAR_ACTIVITY_1] = (0, jsx_runtime_1.jsx)(presentation_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.DEPLOY_SUCCESS] = (0, jsx_runtime_1.jsx)(project_success_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.DEPLOY_FAILURE] = (0, jsx_runtime_1.jsx)(project_fail_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.MASHUP_LEADER] = (0, jsx_runtime_1.jsx)(leader_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.MASHUP_SUBLEADER] = (0, jsx_runtime_1.jsx)(sub_leader_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.MASHUP_STAFF] = (0, jsx_runtime_1.jsx)(staff_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.PROJECT_LEADER] = (0, jsx_runtime_1.jsx)(project_leader_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.PROJECT_SUBLEADER] = (0, jsx_runtime_1.jsx)(project_sub_leader_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.HACKATHON_COMMITTEE] = (0, jsx_runtime_1.jsx)(prepare_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.DEFAULT] = (0, jsx_runtime_1.jsx)(default_score_40_svg_1.default, {}, void 0),
    _a[constants_1.ScoreType.MASHUP_CONTENT_WRITE] = (0, jsx_runtime_1.jsx)(content_write_40_svg_1.default, {}, void 0),
    _a);
var Icon = function (_a) {
    var type = _a.type, _b = _a.size, size = _b === void 0 ? 44 : _b;
    if (!scoreIcon[type])
        return null;
    return react_2.default.cloneElement(scoreIcon[type], {
        width: size,
        height: size,
    });
};
exports.default = Icon;
